import PropTypes from 'prop-types';
import React from 'react';
import { Select } from '@glowforge/ui-common/components';
import './faq-nav-mobile.less';

/**
 * Mobile FAQ Navigation
 */
const MobileNav = ({
  links,
  label,
  currentRoute,
  placeholder,
  onChange,
}) => {
  // Map link objects to objects that 'options' expects
  const options = links.map((link) => ({
    value: link.route,
    label: link.text,
  }));
  return (
    <div className='FAQNavMobile'>
      <Select
        autosize={false}
        className='select'
        label={label}
        value={currentRoute}
        placeholder={placeholder}
        onChange={onChange}
        clearable={false}
        options={options} />
    </div>
  );
};

MobileNav.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    route: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  currentRoute: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MobileNav;
